__turbopack_context__.v({
  "bgStyle": "FirstScreenInfra-module-scss-module__FZxbDa__bgStyle",
  "firstScreenBoxText": "FirstScreenInfra-module-scss-module__FZxbDa__firstScreenBoxText",
  "firstScreenBoxTextMob": "FirstScreenInfra-module-scss-module__FZxbDa__firstScreenBoxTextMob",
  "firstScreenBoxTitle": "FirstScreenInfra-module-scss-module__FZxbDa__firstScreenBoxTitle",
  "firstScreenContainer": "FirstScreenInfra-module-scss-module__FZxbDa__firstScreenContainer",
  "firstScreenDescription": "FirstScreenInfra-module-scss-module__FZxbDa__firstScreenDescription",
  "firstScreenGradient": "FirstScreenInfra-module-scss-module__FZxbDa__firstScreenGradient",
  "firstScreenImg": "FirstScreenInfra-module-scss-module__FZxbDa__firstScreenImg",
  "firstScreenImgMob": "FirstScreenInfra-module-scss-module__FZxbDa__firstScreenImgMob",
  "firstScreenSvg": "FirstScreenInfra-module-scss-module__FZxbDa__firstScreenSvg",
  "firstScreenText": "FirstScreenInfra-module-scss-module__FZxbDa__firstScreenText",
  "firstScreenTitleMob": "FirstScreenInfra-module-scss-module__FZxbDa__firstScreenTitleMob",
  "intro": "FirstScreenInfra-module-scss-module__FZxbDa__intro",
  "introInner": "FirstScreenInfra-module-scss-module__FZxbDa__introInner",
  "seoText": "FirstScreenInfra-module-scss-module__FZxbDa__seoText",
  "svgClass": "FirstScreenInfra-module-scss-module__FZxbDa__svgClass",
  "thirdScreenTitle": "FirstScreenInfra-module-scss-module__FZxbDa__thirdScreenTitle",
});
